<template>
  <div class="stydyDetails">
    <div class="page_header">
      <div class="page_header_left" @click="goBack">
        <i class="el-icon-back"></i>
        <div class="page_header_left_back">返回</div>
        <div class="page_header_content">教师详情</div>
      </div>
      <div class="page_header_control">
        <div class="mwow-button success" @click="edit">编辑</div>
      </div>
    </div>
    <el-row class="page_content">
      <el-col :span="2">
        <div class="page_content_left">
          <el-avatar
            shape="square"
            :size="70"
            fit="fit"
            :src="detailsData.avatar"
            class="page_content_avatar"
          ></el-avatar>
        </div>
      </el-col>
      <el-col :span="22">
        <el-col :span="8">
          <div>
            <div class="column">
              <span class="vertica weight">{{ detailsData.name }}</span>
              <span class="light"></span>
              <span class="vertica">{{ detailsData.sex }}</span>
            </div>
            <div class="column">
              <span class="vertica">
                {{ "+" + detailsData.area_code }} {{ detailsData.mobile }}
              </span>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="next_follow setlh">
            <div>
              <span class="vertica weight smsize right">其他授课：</span>
            </div>
            <div class="next_follow">
              <div class="vertica smsize tearchtals">
                {{ detailsData.other_authorize }}
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="next_follow">
            <div>
              <span class="vertica weight smsize right setlh">科目：</span>
            </div>
            <div class="next_follow tal">
              <span v-if="detailsData.subjects.length === 0">-</span>
              <div
                class="tearchlab"
                v-for="(item, index) in detailsData.subjects"
                :key="index"
              >
                {{ item.subject_title }}
              </div>
            </div>
          </div>
        </el-col>
      </el-col>
    </el-row>
    <div class="page_footer">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!-- 教师简介 -->
        <el-tab-pane label="教师介绍" name="tabDescription">
          <tab-description
            :origin-data="detailsData.detail"
            :readonly="detailsData.directly_under"
          ></tab-description>
        </el-tab-pane>
        <!-- 授课班级 -->
        <el-tab-pane label="授课班级" name="tabClass">
          <tab-class :visible="activeName === 'tabClass'"></tab-class>
        </el-tab-pane>
        <!-- 上课记录 -->
        <el-tab-pane label="上课记录" name="tabLog" class="tab-log">
          <tab-log :visible="activeName === 'tabLog'"></tab-log>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import tabDescription from "./tabDescription.vue";
import tabClass from "./tabClass.vue";
import tabLog from "./tabLog.vue";
import {
  teacherdetail,
  classlist,
  rollCallListData,
  rollCallList,
} from "@/api/teacherManage";
import { rollCallStudentList } from "@/api/rollCall";
import {
  staffList,
  geteacherList,
  getSelectClassList,
  getSelectCourseList,
  autoSearchData,
} from "@/api/globalSearch";
import { dateFormat } from "@/utils/timeFormat";
import { PageModule } from "@/store/module/page";
export default {
  components: {
    tabDescription,
    tabClass,
    tabLog,
  },
  data() {
    return {
      id: 0,
      activeName: "tabDescription",
      detailsData: {
        subjects: [],
        directly_under: 0,
      }, //总数据
      tableData: [],
      page: 1,
      pageSize: 3,
      pageSizeArray: [3, 10, 20],
      total: 5,
      searchInfo: {
        course_id: "",
      }, //授课班级搜索
      dialogVisible: false,
      courseName: "", //课程名字
      className: "", //班级名字
      expireTime: "", //到期时间
      expireTimeClass: "", //课次时间
      tabledialogData: [],
      dialogtotal: 5,
      dialogpage: "",
      dialogpageSize: 10,
      roll_call_id: "",
      dataLoaded: false,
      classNameDilo: "",
    };
  },
  created() {
    const _t = this;
    _t.id = Number(_t.$route.query.id);
    _t.getDataDetails({ staff_id: _t.id }, () => {
      _t.dataLoaded = true;
    });
    const cache = PageModule.pageInfo.teacherDetails;
    if (cache.tab) {
      this.activeName = cache.tab;
      this.getListData();
    } else {
      this.activeName = "tabDescription";
      PageModule.SET_PAGE_INFO({
        name: "teacherDetails",
        key: "tab",
        value: "tabDescription",
      });
    }
    // _t.globalSearch("", "course");
    // _t.globalSearch("", "class");
  },
  methods: {
    lookDetails(e) {
      const _t = this;
      _t.$router.push({
        name: "classManageDetail",
        query: {
          id: e.class_id,
        },
      });
    },
    lookDetailsrollist(e) {
      const _t = this;
      _t.roll_call_id = e.roll_call_id;
      _t.classNameDilo = e.class.name;
      const data = {
        page: 1,
        page_size: 10,
      };
      _t.getrollcallstudentlist(data);
    },
    getrollcallstudentlist(data) {
      const _t = this;
      data.roll_call_id = _t.roll_call_id;
      rollCallStudentList(data).then((res) => {
        if (res.error_code == 0) {
          _t.dialogVisible = true;
          res.data.list.map((a) => {
            a.remark = a.remark == "" ? "无" : a.remark;
            switch (a.student_status) {
              case 1:
                a.student_status = "到课";
                break;
              case 2:
                a.student_status = "迟到";
                break;
              case 3:
                a.student_status = "请假";
                break;
              case 4:
                a.student_status = "未到";
                break;
            }
          });
          _t.tabledialogData = res.data.list;
          _t.dialogtotal = res.data.total;
          _t.dialogpage = res.data.page;
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    edit() {
      this.$router.push({
        name: "editEmployee",
        query: {
          id: this.id + "",
        },
      });
    },
    lookDetailsedit(e) {
      this.$router.push({
        name: "rollCallDetails",
        query: { id: e.roll_call_id },
      });
    },
    // 通用搜索框
    getglobalsearchdata(data, type) {
      if (type == "staff") {
        return staffList(data);
      } else if (type == "teacher") {
        return geteacherList(data);
      } else if (type == "class") {
        return getSelectClassList(data);
      } else if (type == "course") {
        return getSelectCourseList(data);
      }
    },
    async globalSearch(queryString, type) {
      const _t = this;
      let data = {
        page: 1,
        page_size: 100,
      };
      let restaurants = {};
      if (queryString) {
        data = {
          page: 1,
          page_size: 10,
        };
        if (type == "class") {
          data.name = queryString;
        } else if (type == "course") {
          data.title = queryString;
        } else {
          data.key_word = queryString;
        }
      }
      restaurants = await _t.getglobalsearchdata(data, type);
      const list = restaurants.data.list;
      if (type == "staff") {
        //
      } else if (type == "teacher") {
        //
      } else if (type == "class") {
        _t.className = list;
      } else if (type == "course") {
        _t.courseName = list;
      }
    },
    // 通用搜索框结束
    getDataDetails(data, cb) {
      const _t = this;
      teacherdetail(data).then((res) => {
        if (res.error_code == 0) {
          _t.detailsData = res.data;
          if (cb) {
            cb();
          }
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    //上课记录
    getClasslistData(data) {
      const _t = this;
      data.teacher_id = _t.id;
      if (_t.searchInfo.class_id) {
        data.class_id = _t.searchInfo.class_id;
      }
      if (_t.searchInfo.course_id) {
        data.course_id = _t.searchInfo.course_id;
      }
      if (_t.searchInfo.class_id) {
        data.class_id = _t.searchInfo.class_id;
      }
      if (_t.searchInfo.staff_id) {
        data.staff_id = _t.searchInfo.staff_id;
      }
      if (_t.searchInfo.roll_call_start_date) {
        data.roll_call_start_date = _t.searchInfo.roll_call_start_date;
      }
      if (_t.searchInfo.roll_call_end_date) {
        data.roll_call_end_date = _t.searchInfo.roll_call_end_date;
      }
      if (_t.searchInfo.lesson_start_date) {
        data.lesson_start_date = _t.searchInfo.lesson_start_date;
      }
      if (_t.searchInfo.lesson_end_date) {
        data.lesson_end_date = _t.searchInfo.lesson_end_date;
      }
      rollCallList(data).then((res) => {
        if (res.error_code == 0) {
          if (res.data.list != null) {
            res.data.list.map((a) => {
              a.create_time = dateFormat(
                "YYYY-mm-dd HH:MM",
                new Date(Number(a.create_time + "000"))
              );
            });
          }
          _t.tableData = res.data.list;
          _t.total = res.data.total;
          _t.page = res.data.page;
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    //授课班级
    classlistData(data) {
      const _t = this;
      data.staff_id = _t.id;
      classlist(data).then((res) => {
        if (res.error_code == 0) {
          _t.tableData = res.data.list;
          _t.total = res.data.total;
          _t.page = res.data.page;
        } else {
          _t.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    //切换请求数据
    getListData() {
      const _t = this;
      PageModule.SET_PAGE_INFO({
        name: "teacherDetails",
        key: "tab",
        value: _t.activeName,
      });
    },
    handleClick() {
      const _t = this;
      _t.page = 1;
      _t.pageSize = 20;
      _t.getListData();
    },
    handlePagerChange(e) {
      this.page = e;
      this.getListData();
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getListData();
    },
    handledialogChange(e) {
      const _t = this;
      _t.dialogpage = e;
      _t.getrollcallstudentlist({
        page: _t.dialogpage,
        page_size: _t.dialogpageSize,
      });
    },
    handledialogSizeChange(e) {
      const _t = this;
      _t.dialogpageSize = e;
      _t.getrollcallstudentlist({
        page: _t.dialogpage,
        page_size: _t.dialogpageSize,
      });
    },
    handleSearch() {
      const _t = this;
      _t.getClasslistData({
        page: _t.page,
        page_size: _t.pageSize,
      });
    },
    datechoose(e) {
      const _t = this;
      let expire_start_time = "";
      let expire_end_time = "";
      if (e != null) {
        expire_start_time = e[0];
        expire_end_time = e[1];
      }
      _t.searchInfo.roll_call_start_date = expire_start_time;
      _t.searchInfo.roll_call_end_date = expire_end_time;
      _t.handleSearch();
    },
    datechooseClass(e) {
      const _t = this;
      let expire_start_time = "";
      let expire_end_time = "";
      if (e != null) {
        expire_start_time = e[0];
        expire_end_time = e[1];
      }
      _t.searchInfo.lesson_start_date = expire_start_time;
      _t.searchInfo.lesson_end_date = expire_end_time;
      _t.handleSearch();
    },
  },
};
</script>

<style scoped lang="scss">
.stydyDetails {
  // 弹框
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #e7e8ea;
  }
  .setlh {
    line-height: 30px;
  }
  .next_follow {
    display: flex;
    .tal {
      flex-wrap: wrap;
      width: 83%;
      align-items: center;
    }
    .next_follow_left {
      width: 50%;
      height: 60px;
      display: flex;
      align-items: center;
    }
    .next_follow_right {
      width: 50%;
      height: 50px;
      padding-top: 10px;
      display: flex;
      justify-content: flex-end;
      span {
        color: rgba(7, 209, 170, 1);
      }
    }
  }
  /deep/ .el-upload_img {
    .el-upload {
      width: 80px;
      height: 80px;
      line-height: 95px;
    }
  }
  /deep/ .next_follow {
    .el-input__inner {
      height: 28px;
      line-height: 28px;
      width: 200px;
    }
    .el-input__icon {
      line-height: 28px;
    }
  }
  // 弹框end
  //页头
  .page_header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e7e8ea;
    padding-bottom: 9px;
    background: #fff;
    padding: 13px;
  }
  .page_header_left {
    display: flex;
    cursor: pointer;
    position: relative;
    align-items: center;
  }
  .el-icon-back {
    font-size: 18px;
    margin-right: 6px;
    align-self: center;
  }
  .el-icon-back:before {
    content: "\e6ea";
  }
  .page_header_left_back {
    font-size: 14px;
    font-weight: 500;
    margin-right: 40px;
    position: relative;
  }
  .page_header_left_back::after {
    content: "";
    position: absolute;
    width: 1px;
    height: 16px;
    right: -20px;
    top: 50%;
    transform: translateY(-50%);
    background-color: #dcdfe6;
  }
  .page_header_content {
    font-size: 13px;
    font-weight: bold;
    color: #5c5d5e;
  }
  .page_header_control {
    display: flex;
    div:nth-of-type(2) {
      margin: 0 10px;
    }
  }
  //end
  .page_content {
    padding-top: 22px;
    background: #fff;
    padding: 13px;
    .page_content_avatar {
      border-radius: 50%;
      border: 1px solid #e7e8ea;
    }
    .column {
      display: flex;
      align-items: center;
      height: 35px;
      text-align: center;
    }
    .vertica {
      font-size: 16px;
      color: rgba(92, 93, 94, 1);
    }
    .tearchlab {
      padding: 7px 15px;
      margin-bottom: 3px;
      margin-top: 3px;
      margin-right: 10px;
      opacity: 1;
      background: #f6fafc;
      border-radius: 4px;
      color: rgba(92, 93, 94, 1);
    }
    .weight {
      font-weight: bold;
    }
    .light {
      width: 1px;
      height: 16px;
      background-color: #dcdfe6;
      display: inline-block;
      margin: 0 10px;
    }
    .smsize {
      font-size: 14px;
    }
    .right {
      min-width: 25%;
      text-align: right;
    }
  }
  // end
  .page_footer {
    margin-top: 12px;
    min-height: 383px;
    background: #fff;
    padding: 0 13px 13px 13px;
    .footerTabs {
      border: none;
      padding: 0;
      .page_header_control {
        div {
          margin: 0;
          margin-left: 10px;
        }
      }
    }
    .page_header_content {
      color: #5c5d5e;
      font-size: 14px;
    }
    .tabDescription_details {
      font-size: 12px;
      color: #5c5d5e;
      display: flex;
      margin-top: 20px;
      .beleft {
        margin-right: 70px;
      }
      .notDue {
        margin-left: 18px;
        color: #07d1aa;
      }
      .tabDescription_class {
        display: flex;
        align-items: center;
      }
    }
    .tabDescriptionLable {
      padding: 7px 15px;
      background: #f6fafc;
      color: #07d1aa;
      margin-right: 10px;
      display: flex;
      align-items: center;
    }
    .tab-log {
      .footerTabs {
        margin-bottom: 12px;
      }
      .tabDescriptionLable {
        color: #5c5d5e;
        background: #fff7e9;
      }
    }
    .el-form .el-form-item__label {
      text-align: left !important;
    }
    .el-form-item--mini.el-form-item,
    .el-form-item--small.el-form-item {
      margin-bottom: 12px !important;
      margin-right: 80px !important;
      .success {
        margin-right: 0 !important;
      }
    }
    .becalled_header {
      display: flex;
      justify-content: center;
      align-items: center;
      .thisWeek {
        background: #f0fdfa;
        border: 1px solid #38dabb;
        height: 28px;
        width: 44px;
        color: #38dabb;
        border-radius: 4px;
        text-align: center;
        line-height: 28px;
        margin-right: 20px;
      }
      .week_date {
        font-size: 12px;
        color: #5c5d5e;
        margin: 0 20px;
      }
      .week_box {
        display: flex;
        justify-content: center;
        align-items: center;
        .week_box_left {
          width: 28px;
          height: 28px;
          opacity: 1;
          border: 1px solid #e7e8ea;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }
    }
    .question {
      width: 15px;
      height: 15px;
      opacity: 1;
      background: #bebfc0;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      line-height: 16px;
      font-size: 10px;
      margin-left: 5px;
    }
    .followup {
      .footerTabs {
        margin-top: 3px;
        margin-bottom: 20px;
      }
    }
    .followupHead {
      opacity: 1;
      font-size: 16px;
      font-weight: bold;
      text-align: left;
      color: #5c5d5e;
      margin-top: 14px;
    }
    .followupCenter {
      padding: 0 19px;
      background: #f6fafc;
      margin-top: 14px;
    }
    .followupCenterHead {
      display: flex;
      justify-content: space-between;
      height: 44px;
      align-items: center;
    }
    .border {
      border-bottom: 1px solid #e7e8ea;
    }
    .followupCenterHead:last-child {
      margin-bottom: 0;
    }
    .followup_left_details {
      display: flex;
      align-items: center;
    }
    .followupCenter_left {
      display: flex;
      align-items: center;
      .followup_left_details {
        font-size: 12px;
        color: #5c5d5e;
        .followupName {
          font-weight: bold;
        }
      }
    }
    .followupCenter_right {
      display: flex;
      align-items: center;
      .light {
        margin: 0 10px;
      }
    }
    .light {
      width: 1px;
      height: 16px;
      background-color: #dcdfe6;
      display: inline-block;
      margin: 0 20px;
    }
    .FoUpBtn {
      color: #409eff;
    }
    .editBtn {
      color: #07d1aa;
    }
    .closeBtn {
      color: #ffb940;
    }
    .delBtn {
      color: #5c5d5e;
    }
    .red {
      color: #f56c6c;
    }
    .green {
      color: #07d1aa;
    }
  }
}
</style>
